(function () {
  "use strict";
  if (!("IntersectionObserver" in window)) {
    document.querySelectorAll(".ut-es-reveal").forEach(function (el) {
      el.classList.add("is-in");
    });
    return;
  }
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    document.querySelectorAll(".ut-es-reveal").forEach(function (el) {
      el.classList.add("is-in");
    });
    return;
  }
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var d = parseInt(el.getAttribute("data-reveal-delay") || "0", 10);
        setTimeout(function () {
          el.classList.add("is-in");
        }, d);
        io.unobserve(el);
      });
    },
    { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
  );
  document.querySelectorAll(".ut-es-reveal").forEach(function (el, i) {
    if (!el.getAttribute("data-reveal-delay")) {
      el.setAttribute("data-reveal-delay", String((i % 8) * 80));
    }
    io.observe(el);
  });
})();
